import { Filter, IActiveFilters } from 'api-paths-cas';
import { Box, Checkbox, CheckboxGroup } from '@chakra-ui/react';
import { useState } from 'react';

export interface CheckRadioGroupInfoMutli {
  label: string | React.ReactElement;
  value: string[];
  hint?: string;
  checked?: boolean;
  disabled?: boolean;
  indeterminate?: boolean;
  key?: string;
}

export interface IProps {
  filter: Filter;
  list: CheckRadioGroupInfoMutli[];
  activeFilters: IActiveFilters;
}

export interface IDispatchProps {
  saveFilter: (filterKey: string, values: string[]) => void;
}

export const SelectManyMulti = ({ filter, list, saveFilter }: IProps & IDispatchProps): JSX.Element => {
  const checkedOptions = list.filter(item => item.checked);
  // in insights/next-upgrade, the checked option values do not update automatically on the font-end with
  // saveFilter due to an architecture difference with the old insights (no Redux I think?)
  // Changing this value to a state restores all functionality.
  // - Ryan
  const [checkedOptionValues, setCheckedOptionValues] = useState(
    checkedOptions.map(item => item.value.join('%2C')).flat(),
  ); // Modified: Changed to state - Ryan

  if (!list) console.error(`There are no filter values to list for this multi select.`);

  const onChange = (selectedValues: string[]) => {
    const selectedValuesParsed = selectedValues.map(i => i.split('%2C'));
    const selectedValuesFlat = selectedValuesParsed.flat();
    setCheckedOptionValues(selectedValues);
    saveFilter(filter.key, selectedValuesFlat);
  };

  return (
    <Box data-selector="checkbox-group">
      <CheckboxGroup onChange={onChange} value={checkedOptionValues}>
        {list.map(item => {
          const value = item.value.join('%2C');
          const key = item.value.join('%2C');

          return (
            <Checkbox
              key={key}
              value={value}
              data-selector={item.label}
              aria-checked={item.checked}
              variant="ghost"
              mb={0.5}
            >
              {item.label}
            </Checkbox>
          );
        })}
      </CheckboxGroup>
    </Box>
  );
};
